import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Menu, X } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="bg-white shadow-sm" data-id="element-80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <div className="flex justify-between h-16 items-center" data-id="element-82">
          <div className="flex-shrink-0" data-id="element-83">
            <Link to="/" data-id="element-84">
              <Logo data-id="element-85" />
            </Link>
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-86">
            <button type="button" className="text-gray-500 hover:text-gray-700 focus:outline-none" onClick={toggleMenu} data-id="element-87">
              {isMenuOpen ? <X className="h-6 w-6" data-id="element-88" /> : <Menu className="h-6 w-6" data-id="element-89" />}
            </button>
          </div>
          {/* Desktop menu */}
          <nav className="hidden md:flex space-x-8" data-id="element-90">
            <Link to="/" className="text-rose-900 hover:text-rose-700 px-3 py-2 text-sm font-medium" data-id="element-91">
              Home
            </Link>
            <Link to="/service-coverage" className="text-gray-600 hover:text-rose-700 px-3 py-2 text-sm font-medium" data-id="element-92">
              Service Coverage
            </Link>
            <Link to="/about" className="text-gray-600 hover:text-rose-700 px-3 py-2 text-sm font-medium" data-id="element-93">
              About Us
            </Link>
            <Link to="/contact" className="text-gray-600 hover:text-rose-700 px-3 py-2 text-sm font-medium" data-id="element-94">
              Contact Us
            </Link>
            <Link to="/faq" className="text-gray-600 hover:text-rose-700 px-3 py-2 text-sm font-medium" data-id="element-95">
              FAQs
            </Link>
            <div className="relative group" data-id="element-96">
              <button className="text-gray-600 hover:text-rose-700 px-3 py-2 text-sm font-medium flex items-center" data-id="element-97">
                Policies
                <svg className="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-98">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-99" />
                </svg>
              </button>
              <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 hidden group-hover:block" data-id="element-100">
                <Link to="/cancellation-policy" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-101">
                  Cancellation Policy
                </Link>
                <Link to="/refund-policy" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-102">
                  Refund Policy
                </Link>
                <Link to="/privacy-policy" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-103">
                  Privacy & Cookie Policy
                </Link>
                <Link to="/terms" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-104">
                  Terms & Conditions
                </Link>
              </div>
            </div>
          </nav>
          <div className="hidden md:flex items-center" data-id="element-105">
            <a href="tel:08000554969" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-rose-900 hover:bg-rose-800" data-id="element-106">
              0800 055 4969
            </a>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-107">
          <div className="px-2 pt-2 pb-3 space-y-1" data-id="element-108">
            <Link to="/" className="block px-3 py-2 text-base font-medium text-rose-900 hover:text-rose-700" data-id="element-109">
              Home
            </Link>
            <Link to="/service-coverage" className="block px-3 py-2 text-base font-medium text-gray-600 hover:text-rose-700" data-id="element-110">
              Service Coverage
            </Link>
            <Link to="/about" className="block px-3 py-2 text-base font-medium text-gray-600 hover:text-rose-700" data-id="element-111">
              About Us
            </Link>
            <Link to="/contact" className="block px-3 py-2 text-base font-medium text-gray-600 hover:text-rose-700" data-id="element-112">
              Contact Us
            </Link>
            <Link to="/faq" className="block px-3 py-2 text-base font-medium text-gray-600 hover:text-rose-700" data-id="element-113">
              FAQs
            </Link>
            <div className="border-t border-gray-200 mt-2 pt-2" data-id="element-114">
              <p className="px-3 py-2 text-base font-medium text-gray-600" data-id="element-115">
                Policies
              </p>
              <Link to="/cancellation-policy" className="block px-3 py-2 text-sm font-medium text-gray-600 hover:text-rose-700 pl-6" data-id="element-116">
                Cancellation Policy
              </Link>
              <Link to="/refund-policy" className="block px-3 py-2 text-sm font-medium text-gray-600 hover:text-rose-700 pl-6" data-id="element-117">
                Refund Policy
              </Link>
              <Link to="/privacy-policy" className="block px-3 py-2 text-sm font-medium text-gray-600 hover:text-rose-700 pl-6" data-id="element-118">
                Privacy & Cookie Policy
              </Link>
              <Link to="/terms" className="block px-3 py-2 text-sm font-medium text-gray-600 hover:text-rose-700 pl-6" data-id="element-119">
                Terms & Conditions
              </Link>
            </div>
            <div className="mt-4" data-id="element-120">
              <a href="tel:08000554969" className="block w-full text-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-rose-900 hover:bg-rose-800" data-id="element-121">
                0800 055 4969
              </a>
            </div>
          </div>
        </div>}
    </header>;
};